import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Select } from '@rmwc/select';
import SummaryTotal from './SummaryTotal';
import { getComparisionData, prepareNewBuilding, setManufacturer, handleSummaryComapreModal, getManufacturerStateQuoteForNonLoggedIn } from '../../../action';
import ManufactureDropdown from './ManufactureDropdown';
import Summary from '../Summary/Summary';
import Higher from '../../../assets/images/comparePrice/higher.svg';
import Average from '../../../assets/images/comparePrice/average.svg';
import Lowest from '../../../assets/images/comparePrice/lowest.svg';
import HigherIpad from '../../../assets/images/comparePrice/red-strip.svg';
import AverageIpad from '../../../assets/images/comparePrice/grey-strip.svg';
import LowestIpad from '../../../assets/images/comparePrice/green-strip.svg';
import HelpIcon from '../../../assets/images/comparePrice/help-icon.svg';
import BuildingSummaryIcon from '../../../assets/images/comparePrice/building-summary.svg';
import { sleep } from '../../../redux/reducers/utils';
import { getManufactureDataById } from '../../../services/manufacture.services';
import { getManufactureDetails } from '../../../action/manufacturers_auth/login.action';
// import { OverlayTrigger, Tooltip } from 'react-bootstrap';

function formatNumberInThreshHold(value) {
    if (value === 0) {
        return false;
    }
    const units = [
        { threshold: 1e12, suffix: 'T' },
        { threshold: 1e9, suffix: 'B' },
        { threshold: 1e6, suffix: 'M' },
        { threshold: 1e3, suffix: 'k' },
    ]
    for (const unit of units) {
        const { threshold, suffix } = unit;
        if (value >= threshold) {
            return (value / threshold).toFixed(1).replace(/\.0$/, '') + suffix;
        }
    }
    return String(value);
}

const LoadingView = () => (
    <div className='choose-manufacturer '>
        <div className='manufacturer-loading'>
            <div className='spinner-loading'>
                <div className='spinner'>
                </div>
                <div className='spinner-value'>Loading</div>
            </div>
            <div className='loading-text'>
                <h3>Please wait...</h3>
                <span>We're comparing your building</span>
            </div>
        </div>
    </div>
);

const QuoteStateContent = ({ quoteStateData, isList }) => {
    const WrapperTag = isList ? 'li' : 'span';

    return (
        <>
            {quoteStateData && quoteStateData?.total_quote > 0 && (
                <WrapperTag className='order-text-container'>
                    More than{' '}
                    <span className='order-text-focused add-border'>
                        {formatNumberInThreshHold(quoteStateData?.total_quote)}
                    </span>{' '}
                    quotes processed with{' '}
                    <span className='order-text-focused'>SENSEI</span>
                </WrapperTag>
            )}
            {quoteStateData?.total_state > 0 && (
                <WrapperTag className='order-text-container'>
                    Serving In :{' '}
                    <span className='order-text-focused'>
                        {quoteStateData?.total_state} States
                    </span>
                </WrapperTag>
            )}
        </>
    );
};

const PriceDetailTooltip = ({ item, priceDetailRef, closePriceDetail }) => (
    <div ref={priceDetailRef} className='price-detail-tooltip'>
        <SummaryTotal item={item} mode='popup' />
        <i
            className='icon-close'
            onClick={closePriceDetail}></i>
    </div>
);

const CompareSummary = ({ item, surchargeObj }) => (
    <div className='detail-wrapper'>
        <SummaryTotal item={item} surchargeObj={surchargeObj} />
        <div className='summary-detail-container'>
            <div className='building-summary-container'>
                <img src={process.env.REACT_APP_BASE_URL + BuildingSummaryIcon} alt='building summary' />
                <div className='building-summary-title'>Building Summary</div>
            </div>
            <Summary item={item} isFromComapre={true} />
        </div>
    </div>
);

const SelectManufacturerCard = ({ loading, value, onChange, options }) => (
    <div className={`choose-manufacturer ${(loading == '1' || loading == '2') ? ' disabled' : ''}`}>
        <div className='choose-title'>
            Select Manufacturer to Compare
        </div>
        <div className='choose-text'>
            Choose a manufacturer & compare their prices with other top manufacturer. you'll find the perfect building at the best price.
        </div>
        <ManufactureDropdown
            label="Select Manufacturer"
            value={value}
            onChange={onChange}
            options={options}
        />
    </div>
);

const NoCompareDataView = ({ message }) => (
    <div className="no-manufacturer-select no-compare-data">
        <div className="top-section-box">
            <div>
                <span className="icon-report-data icon"></span>
            </div>
            <h6>No Data Available</h6>
            <p>{message}</p>
        </div>
    </div>
);

const ComparePrice = ({ startAnimation, handleStartAnimation, setLoading, loading, mainManufactureQuoteStateData, handleTabSelect, custom }) => {

    const state = useSelector(state => state.reducer);
    const dispatch = useDispatch()

    const [selectedPriceDetail, setSelectedPriceDetail] = useState(-1);
    const [showPriceDetail, setShowPriceDetail] = useState(false);
    const [showComment, setShowComment] = useState(false)
    const [QuoteStateCount, setQuoteStateCount] = useState()

    let CompareFirstMfg =
        state.const_var.ComparisionDataArray[state.params.m_s_n_1]
            ? state.const_var.ComparisionDataArray[state.params.m_s_n_1].post_data?.building
            : "";
    let CompareSecondMfg =
        state.const_var.ComparisionDataArray[state.params.m_s_n_2] != undefined
            ? state.const_var.ComparisionDataArray[state.params.m_s_n_2].post_data?.building
            : "";

    const getQuoteandStateCount = async (manufactureId, index) => {
        let quoteCountResponse = false;

        if (manufactureId) {
            quoteCountResponse = await getManufacturerStateQuoteForNonLoggedIn(manufactureId);
            if (quoteCountResponse) {
                setQuoteStateCount(prev => ({ ...prev, [index]: quoteCountResponse }))
                return quoteCountResponse
            } else {
                return null
            }
        }
    }

    const selectManufacturer = (selectedId, selectedIndex, quoteStateCountData) => {
        handleStartAnimation(true)
        if (selectedIndex == "_1") {
            dispatch(setManufacturer(1))
            dispatch(getComparisionData(selectedId, "_1", quoteStateCountData));
        }
        if (selectedIndex == "_2") {
            dispatch(setManufacturer(2))
            dispatch(getComparisionData(selectedId, "_2"));
        }
        handleStartAnimation(true)
    }

    const priceDetailRef = useRef(null);

    const closePriceDetail = (event) => {
        if (event) {
            event.stopPropagation()
        }
        setShowPriceDetail(false);
        setSelectedPriceDetail(-1)
    }

    const handleOutsideClick = (event) => {
        if (priceDetailRef.current && !priceDetailRef.current.contains(event.target)) {
            closePriceDetail()
        }
    }

    useEffect(() => {
        document.addEventListener('mousedown', handleOutsideClick);
        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, [])

    useEffect(() => {
        if (state.const_var.comparisionLoadermfg1 == true) {
            setLoading('1');
        }
        else if (state.const_var.comparisionLoadermfg2 == true) {
            setLoading('2');
        }
        else {
            setLoading('0');
        }
    }, [state.const_var.comparisionLoadermfg1, state.const_var.comparisionLoadermfg2, state.const_var.NoCompareData1, state.const_var.NoCompareData2])

    const holdClick = async (item, state) => {
        await sleep(2000)
        if (item.compareManufactureIndex == "_1") {
            dispatch(prepareNewBuilding(state.params.m_s_n_1))
        }
        if (item.compareManufactureIndex == "_2") {
            dispatch(prepareNewBuilding(state.params.m_s_n_2))
        }
        const selectedState = state.const_var.stateManufactureDataFromApi.find((item) => item.id === state.params.p_s_n);
        state.params.manufactureKey = selectedState.manufacturer_list.find((manufacture) => manufacture.id === item.manufactureId).u_id;
        dispatch(getManufactureDetails(state.params.manufactureKey, false));
        handleTabSelect && handleTabSelect(0);
        dispatch(handleSummaryComapreModal())
    }

    const comment = 'Competitive offers are available from other manufacturers for the designed building. Please review the building details before finalizing any offer. ';
    if (!state.const_var.loginSession) return null

    let firstManufactureCompareData = state.const_var?.ComparisionDataArray?.[state.params.m_s_n_1]?.post_data?.building ?? '';
    let secondManufactureCompareData = state.const_var?.ComparisionDataArray?.[state.params.m_s_n_2]?.post_data?.building ?? '';

    const setCustomDownPayment = (manufactureCompareData) => {
        if (manufactureCompareData != undefined && manufactureCompareData.BuildingPriceArrarNew != undefined && manufactureCompareData.BuildingPriceArrarNew["custom_down_payment_total"] == undefined) {
            manufactureCompareData.BuildingPriceArrarNew["custom_down_payment_total"] = 0
        }
    }

    setCustomDownPayment(firstManufactureCompareData)
    setCustomDownPayment(secondManufactureCompareData)

    const getGrandTotal = (manufactureData) => {
        if (!manufactureData?.BuildingPriceArrarNew)
            return 0

        const new_down_payment_total    = Number(manufactureData?.BuildingPriceArrarNew?.["new_down_payment_total"]) ?? 0;
        const custom_down_payment_total = Number(manufactureData?.BuildingPriceArrarNew?.["custom_down_payment_total"]) ?? 0;
        const grvy_value = Number(manufactureData?.BuildingPriceArrarNew?.["grvy_value"]) ?? 0;
        return (new_down_payment_total+ custom_down_payment_total + grvy_value).toFixed(2);
    }
    let grandTotalFirstManu = (firstManufactureCompareData?.BuildingPriceArrarNew && state.const_var?.showComparePrices) ?
        getGrandTotal(firstManufactureCompareData) : 0;


    let grandTotalSecondManu = (secondManufactureCompareData?.BuildingPriceArrarNew && state.const_var?.showComparePrices) ?
        getGrandTotal(secondManufactureCompareData) : 0;

    const DOWN_PAYMENT_TOTAL = Number(state?.const_var?.BuildingPriceArrar?.["new_down_payment_total"]) ?? 0;
    const CUSTOM_DOWN_PAYMENT_TOTAL = Number(state.const_var.BuildingPriceArrar["custom_down_payment_total"]) ?? 0;
    const GRVY_VALUE = Number(state.const_var?.BuildingPriceArrar?.["grvy_value"]) ?? 0
    let grandTotalMainManu = (state.const_var?.BuildingPriceArrar) ? (DOWN_PAYMENT_TOTAL + CUSTOM_DOWN_PAYMENT_TOTAL + GRVY_VALUE).toFixed(2) : 0;
    let mainManufactureData = state.const_var?.post_data?.building;

    const manufacturerList = [
        {
            manufacturer: 'Manufacturer1',
            tags: ['Lowest Price', 'Experienced', 'Quick Delivery', 'Positive Customer Reviews', 'Great Crews', 'Competitive Price', 'Best Reviewed', 'Best Reviewed', 'Experienced', 'Quick Delivery', 'Local Favorite'],
            ratings: [
                { title: 'Price', value: 5.0 },
                { title: 'Components', value: 2.0 },
                { title: 'Quality', value: 3.0 },
                { title: 'Installation Time', value: 5.0 },
                { title: 'Call Support', value: 4.6 }
            ],
            special: '55%',
            specialBuildings: ['32x21 Metal Building', '34x46 Metal Building', '40â€™ Wide Metal Buildings', '46â€™ Wide Metal Buildings'],
            buildingType_id: 1,
            price: grandTotalMainManu,
            compareManufactureIndex: "0",
            manufactureId: state.params.m_s_n,
            orders: '500K',
            servingIn: 25,
            quoteStateCountData: mainManufactureQuoteStateData
        },
        {
            manufacturer: 'Manufacturer2',
            tags: ['Lowest Price', 'Experienced', 'Quick Delivery', 'Positive Customer Reviews', 'Great Crews', 'Competitive Price', 'Best Reviewed', 'Best Reviewed', 'Experienced', 'Quick Delivery', 'Local Favorite'],
            ratings: [
                { title: 'Price', value: 5.0 },
                { title: 'Components', value: 2.0 },
                { title: 'Quality', value: 3.0 },
                { title: 'Installation Time', value: 5.0 },
                { title: 'Call Support', value: 4.6 }
            ],
            special: '55%',
            specialBuildings: ['32x21 Metal Building', '34x46 Metal Building', '40â€™ Wide Metal Buildings', '46â€™ Wide Metal Buildings'],
            buildingType_id: 1,
            price: grandTotalFirstManu,
            compareManufactureIndex: "_1",
            manufactureId: state.params.m_n_f_1,
            orders: '300K',
            servingIn: 25,
            quoteStateCountData: state.const_var.ComparisionDataArray[state.params.m_s_n_1]?.quoteStateCountData
        },
        {
            tags: ['Quick Delivery', 'Best Reviewed', 'New Shop', 'Positive Customer Reviews', 'Great Crews', 'Competitive Price'],
            ratings: [
                { title: 'Price', value: 5.0 },
                { title: 'Components', value: 4 },
                { title: 'Quality', value: 3.9 },
                { title: 'Installation Time', value: 5.0 },
                { title: 'Call Support', value: 5.0 }
            ],
            special: '20%',
            specialBuildings: ['32x21 Metal Building', '34x46 Metal Building', '40â€™ Wide Metal Buildings', '46â€™ Wide Metal Buildings'],
            buildingType_id: 1,
            price: grandTotalSecondManu,
            compareManufactureIndex: "_2",
            manufactureId: state.params.m_n_f_2,
            orders: '100K',
            servingIn: 15,
            quoteStateCountData: state.const_var.ComparisionDataArray[state.params.m_s_n_2]?.quoteStateCountData
        },
    ]

    const stateManufacturerAcordingAPI = state.const_var.stateManufacturerAcordingAPI[state.params.p_s_n] || [];

    let MFGData = [];
    if (stateManufacturerAcordingAPI.length > 0 && state.const_var.user_type_for_comparision != '' && state.const_var.loginSession == true) {
        MFGData = stateManufacturerAcordingAPI.filter(data => data.id != state.params.m_s_n);
    }

    const isManufacturerEmpty = (value) => value == "" || value == null || value == "Select";

    const getCompareState = (item, index) => {
        const hasFirstManufacture = state.params.m_n_f_1 != '';
        const hasSecondManufacture = state.params.m_n_f_2 != '';
        const hasFirstPrice = grandTotalFirstManu > 0;
        const hasSecondPrice = grandTotalSecondManu > 0;

        if ((index === 0 && !hasFirstManufacture && !hasSecondManufacture) || (index === 0 && !hasFirstPrice && !hasSecondPrice)) {
            return 'default';
        }
        if (index === 1 && hasFirstManufacture && hasFirstPrice && loading == '1') {
            return '';
        }
        if (index === 2 && state.params.m_n_f_2 == '') {
            return '';
        }
        if (index === 2 && hasSecondManufacture && hasSecondPrice && loading == '2') {
            return '';
        }
        if (index === 0 && hasSecondManufacture && hasSecondPrice && state.params.m_n_f_1 == '') {
            if (grandTotalSecondManu < grandTotalMainManu) {
                return "higher"
            } else {
                return "lowest"
            }
        }
        if (index === 2 && hasSecondManufacture && hasSecondPrice && state.params.m_n_f_1 == '') {
            if (grandTotalSecondManu > grandTotalMainManu) {
                return "higher"
            } else {
                return "lowest"
            }
        }
        if (state.params.m_n_f_1 == '') {
            return ''
        } else if (hasFirstManufacture && hasFirstPrice && state.const_var.NoCompareData1 == true && state.const_var.NoCompareData2 == false) {
            return '';
        } else if (hasSecondManufacture && hasSecondPrice && state.const_var.NoCompareData1 == true && state.const_var.NoCompareData2 == true) {
            return '';
        } else {
            if (grandTotalMainManu && hasFirstPrice && hasSecondPrice) {
                if (index === 0) {
                    if (Number(grandTotalMainManu) == Number(grandTotalFirstManu) == Number(grandTotalSecondManu)) {
                        return 'average'
                    } else if (Number(grandTotalMainManu) >= Number(grandTotalFirstManu) && Number(grandTotalMainManu) >= Number(grandTotalSecondManu)) {
                        return 'higher'
                    } else if (Number(grandTotalMainManu) < Number(grandTotalFirstManu) && Number(grandTotalFirstManu) < Number(grandTotalSecondManu)) {
                        return 'lowest'
                    } else if (Number(grandTotalMainManu) > Number(grandTotalFirstManu) && Number(grandTotalMainManu) < Number(grandTotalSecondManu)) {
                        return 'average'
                    } else if (Number(grandTotalMainManu) < Number(grandTotalFirstManu) && Number(grandTotalMainManu) > Number(grandTotalSecondManu)) {
                        return 'average'
                    } else {
                        return 'lowest'
                    }
                }
                if (index == 1) {
                    if (Number(grandTotalMainManu) == Number(grandTotalFirstManu) == Number(grandTotalSecondManu)) {
                        return 'average'
                    } else if (Number(grandTotalFirstManu) >= Number(grandTotalMainManu) && Number(grandTotalFirstManu) >= Number(grandTotalSecondManu)) {
                        return 'higher'
                    } else if (Number(grandTotalFirstManu) < Number(grandTotalMainManu) && Number(grandTotalMainManu) < Number(grandTotalSecondManu)) {
                        return 'lowest'
                    } else if (Number(grandTotalFirstManu) > Number(grandTotalMainManu) && Number(grandTotalFirstManu) < Number(grandTotalSecondManu)) {
                        return 'average'
                    } else if (Number(grandTotalFirstManu) < Number(grandTotalMainManu) && Number(grandTotalFirstManu) > Number(grandTotalSecondManu)) {
                        return 'average'
                    } else {
                        return 'lowest'
                    }
                }
                if (index == 2) {
                    if (Number(grandTotalMainManu) == Number(grandTotalFirstManu) == Number(grandTotalSecondManu)) {
                        return 'average'
                    } else if (Number(grandTotalSecondManu) >= Number(grandTotalMainManu) && Number(grandTotalSecondManu) >= Number(grandTotalFirstManu)) {
                        return 'higher'
                    } else if (Number(grandTotalSecondManu) < Number(grandTotalMainManu) && Number(grandTotalMainManu) < Number(grandTotalFirstManu)) {
                        return 'lowest'
                    } else if (Number(grandTotalSecondManu) > Number(grandTotalMainManu) && Number(grandTotalSecondManu) < Number(grandTotalFirstManu)) {
                        return 'average'
                    } else if (Number(grandTotalSecondManu) < Number(grandTotalMainManu) && Number(grandTotalSecondManu) > Number(grandTotalFirstManu)) {
                        return 'average'
                    } else {
                        return 'lowest'
                    }
                }
            } else if (grandTotalMainManu && hasFirstPrice) {
                if (index === 0) {
                    if (Number(grandTotalMainManu) == Number(grandTotalFirstManu)) {
                        return 'average'
                    } else if (Number(grandTotalMainManu) >= Number(grandTotalFirstManu)) {
                        return 'higher'
                    } else if (Number(grandTotalMainManu) < Number(grandTotalFirstManu)) {
                        return 'lowest'
                    } else {
                        return 'lowest'
                    }
                }
                if (index == 1) {
                    if (Number(grandTotalMainManu) == Number(grandTotalFirstManu)) {
                        return 'average'
                    } else if (Number(grandTotalFirstManu) >= Number(grandTotalMainManu)) {
                        return 'higher'
                    } else if (Number(grandTotalFirstManu) < Number(grandTotalMainManu)) {
                        return 'lowest'
                    } else {
                        return 'lowest'
                    }
                }
            } else if (grandTotalMainManu && hasSecondPrice) {
                if (index === 0) {
                    if (Number(grandTotalMainManu) == Number(grandTotalSecondManu)) {
                        return 'average'
                    } else if (Number(grandTotalMainManu) >= Number(grandTotalSecondManu)) {
                        return 'higher'
                    } else if (Number(grandTotalMainManu) < Number(grandTotalSecondManu)) {
                        return 'lowest'
                    } else {
                        return 'lowest'
                    }
                }
                if (index == 2) {
                    if (Number(grandTotalMainManu) == Number(grandTotalSecondManu)) {
                        return 'average'
                    } else if (Number(grandTotalSecondManu) > Number(grandTotalMainManu)) {
                        return 'higher'
                    } else if (Number(grandTotalSecondManu) < Number(grandTotalMainManu)) {
                        return 'lowest'
                    } else {
                        return 'lowest'
                    }
                }
            }
        }
    }

    const twoSection = stateManufacturerAcordingAPI.length <= 2 ? 'two-section-container' : ''
    const isDesktopView = window.innerWidth > 1400;

    let surchargeObj = {
        'surFlag': false,
        'surValue': '',
        'surFlag1': false,
        'surValue1': '',
        'surFlag2': false,
        'surValue2': '',
    }

    const getManufacturerOptions = (selectedId) => {
        return MFGData.filter(mnf => mnf.id != selectedId).map((val) => {
            return {
                "value": val.id,
                "label": val.name
            }
        })
    }

    const getQuoteStateData = (index) => {
        if (index === 0) {
            return mainManufactureQuoteStateData;
        }

        return QuoteStateCount && QuoteStateCount[index];
    }

    const getHeaderImage = (compareState) => {
        if (compareState === 'higher') {
            return process.env.REACT_APP_BASE_URL + (isDesktopView ? Higher : HigherIpad);
        }
        if (compareState === 'lowest') {
            return process.env.REACT_APP_BASE_URL + (isDesktopView ? Lowest : LowestIpad);
        }
        return process.env.REACT_APP_BASE_URL + (isDesktopView ? Average : AverageIpad);
    }

    const updateSurchargeObj = (item, viewSummaryData) => {
        if (item?.compareManufactureIndex == "0") {
            if (
                state.const_var.BuildingPriceArrar["surcharge_amount"] != undefined &&
                state.const_var.BuildingPriceArrar["surcharge_amount"] != 0 &&
                state.const_var.stateManufacturerAcordingAPIDiscount["surcharge"] != undefined &&
                state.const_var.stateManufacturerAcordingAPIDiscount["surcharge"][state.params.m_s_n] !== undefined
            ) {
                if (
                    state.const_var.post_data.building != undefined &&
                    state.const_var.post_data.building.surcharge_taxable != 0
                ) {
                    surchargeObj['surValue'] = "(+Surcharge)";
                } else {
                    surchargeObj['surValue'] = "";
                }
                if (
                    state.const_var.post_data.building != undefined &&
                    state.const_var.post_data.building.surcharge_on_discounted_subtotal == 1
                ) {
                    surchargeObj['surFlag'] = true;
                } else {
                    surchargeObj['surFlag'] = false;
                }
            }
        }

        if (item?.compareManufactureIndex != "0") {
            if (
                viewSummaryData != undefined &&
                state.const_var.stateManufacturerAcordingAPIDiscount["surcharge"] != undefined &&
                state.const_var.stateManufacturerAcordingAPIDiscount["surcharge"][viewSummaryData.manufacturer] !== undefined
            ) {
                if (viewSummaryData != undefined && viewSummaryData.surcharge_taxable != 0) {
                    if (item?.compareManufactureIndex == '_2') {
                        surchargeObj['surValue2'] = "(+Surcharge)";
                    } else {
                        surchargeObj['surValue1'] = "(+Surcharge)";
                    }
                } else {
                    if (item?.compareManufactureIndex == '_2') {
                        surchargeObj['surValue2'] = "";
                    } else {
                        surchargeObj['surValue1'] = "";
                    }
                }
                if (viewSummaryData != undefined && viewSummaryData.surcharge_on_discounted_subtotal == 1) {
                    if (item?.compareManufactureIndex == '_2') {
                        surchargeObj['surFlag2'] = true;
                    }
                    else {
                        surchargeObj['surFlag1'] = true;
                    }
                } else {
                    if (item?.compareManufactureIndex == '_2') {
                        surchargeObj['surFlag2'] = false;
                    }
                    else {
                        surchargeObj['surFlag1'] = false;
                    }
                }
            }
        }
    }

    const openPriceDetail = (event, index) => {
        event.stopPropagation()
        setSelectedPriceDetail(index)
        setShowPriceDetail(true)
    }

    const renderManufacturerTitle = (item, index) => {
        if (item.compareManufactureIndex == "0") {
            return (
                <div className='manufacturer-name'>
                    <span>
                        {mainManufactureData?.manufacturer_name}
                    </span>
                    {index === 0 && <div className='state-badge'>Current</div>}
                </div>
            );
        }

        if (item.compareManufactureIndex == "_1") {
            return (
                <div className='manufacturer-name'>
                    <Select
                        id='manufacture_1'
                        ripple="RipplePropF"
                        options={getManufacturerOptions(state.params.m_n_f_2)}
                        value={item.manufactureId}
                        onChange={async (e) => {
                            setLoading('1')
                            handleStartAnimation(true)
                            const data = await getQuoteandStateCount(e.target.value, index);
                            console.log("data", data);
                            dispatch(setManufacturer(1));
                            dispatch(getComparisionData(data.id, item.compareManufactureIndex, e.target.value))
                        }}
                    />
                </div>
            );
        }

        return (
            <div className='manufacturer-name'>
                <Select
                    id='manufacture_2'
                    ripple="RipplePropF"
                    options={getManufacturerOptions(state.params.m_n_f_1)}
                    value={item.manufactureId}
                    onChange={async (e) => {
                        setLoading('1')
                        handleStartAnimation(true)
                        const data = await getQuoteandStateCount(e.target.value, index)
                        console.log("data", data);
                        dispatch(setManufacturer(2))
                        dispatch(getComparisionData(e.target.value, item.compareManufactureIndex))
                    }}
                />
            </div>
        );
    }

    const renderPriceDetail = (item, index, buidingPriceArr, compareState) => {
        const subTotalValue =  buidingPriceArr?.["sub_order_total"].toFixed(2) ?? 0;
        return (
            <div className='price-container'>
                <div className='price-detail'>
                    <div className=''>
                        <div className={`price-value ${compareState}`}>
                            ${parseFloat(item.price).toFixed(2)}
                            <i
                                className='icon-info-ico'
                                onClick={(event) => openPriceDetail(event, index)}>
                            </i>
                            {!isDesktopView && <div className='price-label'>Due Today (Down Payment)</div>}
                        </div>
                        {isDesktopView && <div className='price-label'>Due Today (Down Payment)</div>}
                        <div className='sub-total-price-container'>
                            <div className='sub-total-price-title'>
                                Sub Total:
                            </div>
                            <div className='sub-total-price-value'>
                                ${subTotalValue}
                            </div>
                        </div>
                    </div>

                    {showPriceDetail && index === selectedPriceDetail &&
                        <PriceDetailTooltip
                            item={item}
                            priceDetailRef={priceDetailRef}
                            closePriceDetail={closePriceDetail}
                        />
                    }
                </div>
                {item.compareManufactureIndex != 0 &&
                    <div>
                        <button className="btn btn-primary pick-building" onClick={() => holdClick(item, state)}>
                            PICK THIS BUILDING
                        </button>
                    </div>
                }
            </div>
        );
    }

    const renderManufacturerInfo = (item, index, buidingPriceArr, compareState) => {
        if (isDesktopView) {
            return (
                <>
                    <div className='left-container'>
                        {renderManufacturerTitle(item, index)}
                        <div className='tags-container'>
                            <QuoteStateContent quoteStateData={getQuoteStateData(index)} />
                        </div>
                    </div>
                    <div className='right-container'>
                        {renderPriceDetail(item, index, buidingPriceArr, compareState)}
                    </div>
                </>
            );
        }

        return (
            <div className='ipad-header-container'>
                {renderManufacturerTitle(item, index)}
                {renderPriceDetail(item, index, buidingPriceArr, compareState)}
                <ul className='tags-container'>
                    <QuoteStateContent quoteStateData={getQuoteStateData(index)} isList={true} />
                </ul>
            </div>
        );
    }

    const renderChooseManufacturer = (index) => {
        if (index === 1 && (state.const_var.NoCompareData1 == true || isManufacturerEmpty(state.params.m_n_f_1))) {
            return (
                <SelectManufacturerCard
                    loading={loading}
                    value={state.params.m_n_f_1}
                    onChange={(value) => {
                        if (state.params.m_n_f_1 != value) {
                            getQuoteandStateCount(value, 1)
                            setLoading('1');
                            selectManufacturer(value, "_1")
                        }
                    }}
                    options={getManufacturerOptions(state.params.m_n_f_2)}
                />
            );
        }

        if (
            index === 2 &&
            (state.const_var.NoCompareData2 == true || isManufacturerEmpty(state.params.m_n_f_2)) &&
            (!state.const_var.loginSession || (state.const_var.loginSession && stateManufacturerAcordingAPI.length > 2))
        ) {
            return (
                <SelectManufacturerCard
                    loading={loading}
                    value={state.params.m_n_f_2}
                    onChange={(value) => {
                        if (state.params.m_n_f_2 != value) {
                            getQuoteandStateCount(value, 2)
                            setLoading('2');
                            selectManufacturer(value, "_2")
                        }
                    }}
                    options={getManufacturerOptions(state.params.m_n_f_1)}
                />
            );
        }

        return null;
    }

    const noCompareMessage = !state.const_var.isTBSOldQuotesForVerticalRoof && state.params.m_n_f_2 == 13 && state.params.p_r_s !== 3
        ? 'Please select the Vertical Roof Style for your building to add End Lean Tos.'
        : 'There is no data available with this size, please consider changing the manufacturer for prices.';

    return (
        <div className={`compare-price-wrapper scroll-${selectedPriceDetail} ${twoSection}`}>
            <div className='header-container'>
                <div className='compare-heading'>
                    <div className='header-title'>Compare Price</div>
                    <div className='comment-container'>
                        {showComment ?
                            <>
                                {comment + ' '}
                                <span onClick={() => setShowComment(false)}>read less</span>
                            </>
                            :
                            <>
                                {comment.substring(0, 50) + '...'}
                                <span onClick={() => setShowComment(true)}>read more</span>
                            </>
                        }
                    </div>
                </div>
                <div className='building-container'>
                    <div className='compare-select'>
                        <div>
                            <div className='label'>Building Type</div>
                            <div className='value'>{state.params.building_type_name}</div>
                        </div>
                    </div>
                    <div className='compare-select'>
                        <div>
                            <div className='label'>Width</div>
                            <Select
                                className='disabled opc-1'
                                value={state.params.p_w}
                                options={state.const_var.buildingWidthArray}
                            />
                        </div>
                    </div>
                    <div className='compare-select'>
                        <div>
                            <div className='label'>Length</div>
                            <Select
                                className='disabled opc-1'
                                value={state.params.p_d}
                                options={state.const_var.buildingLengthArray}
                            />
                        </div>
                    </div>
                    <div className='compare-select'>
                        <div>
                            <div className='label'>Height</div>
                            <Select
                                className='disabled opc-1'
                                value={state.params.p_h}
                                options={state.const_var.buildingHeightArray}
                            />
                        </div>
                    </div>
                </div>
                <div className='help-container'>
                    <img src={process.env.REACT_APP_BASE_URL + HelpIcon} alt="help icon" />
                    <div className='help-content'>
                        Prices are subject to change based on regional permits and certifications following inspection.
                    </div>
                </div>
                <button className="close" onClick={custom}>
                    <span className="icon-close"></span>
                </button>
            </div>

            <div className='manufacturer-container'>
                {manufacturerList.map((item, index) => {
                    let viewSummaryData =
                        item != undefined && item.compareManufactureIndex == "_1"
                            ? CompareFirstMfg
                            : CompareSecondMfg;

                    let buidingPriceArr = viewSummaryData != undefined && viewSummaryData.BuildingPriceArrarNew;
                    if (item?.compareManufactureIndex == "0") {
                        buidingPriceArr = state.const_var.BuildingPriceArrar;
                    }

                    updateSurchargeObj(item, viewSummaryData)

                    const compareState = getCompareState(item, index);
                    const isLoadingCard = (loading == '1' && index === 1) || (loading == '2' && index === 2);
                    const showMainCard = index === 0;
                    const showFirstCompareCard = index === 1 && !isManufacturerEmpty(state.params.m_n_f_1) && state.const_var.NoCompareData1 != true;
                    const showSecondCompareCard = index === 2 && !isManufacturerEmpty(state.params.m_n_f_2) && state.const_var.NoCompareData2 != true;
                    const showCompareCard = showMainCard || showFirstCompareCard || showSecondCompareCard;
                    const showNoCompareData = (state.const_var.NoCompareData1 == true && index === 1) || (state.const_var.NoCompareData2 == true && index === 2);

                    return (
                        <div key={index} className={`manufacturer-item item-${compareState} ${(index === 2 && twoSection != '') ? 'd-none' : ''}`}>
                            {isLoadingCard ?
                                <LoadingView />
                                :
                                <>
                                    {showCompareCard ?
                                        <>
                                            <div className='item-info'>
                                                {renderManufacturerInfo(item, index, buidingPriceArr, compareState)}
                                                {(compareState !== '' && compareState !== 'default') &&
                                                    <div className={`price-scale ${compareState}`}>{compareState} Price </div>
                                                }
                                                <div className='header-image-container'>
                                                    <img src={getHeaderImage(compareState)} alt={`${compareState || 'average'}-header`} />
                                                </div>
                                            </div>
                                            <CompareSummary item={item} surchargeObj={surchargeObj} />
                                        </>
                                        :
                                        <></>
                                    }

                                    <div className='item-detail'>
                                        {renderChooseManufacturer(index)}
                                    </div>

                                    {showNoCompareData &&
                                        <NoCompareDataView message={noCompareMessage} />
                                    }
                                </>
                            }
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export default ComparePrice
